import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-program-achievement-test-grammar',
  templateUrl: './program-achievement-test-grammar.component.html',
  styleUrls: ['./program-achievement-test-grammar.component.scss']
})
export class ProgramAchievementTestGrammarComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
